import { render } from "./ParametroUsuario.vue?vue&type=template&id=944f1822&ts=true"
import script from "./ParametroUsuario.vue?vue&type=script&lang=ts"
export * from "./ParametroUsuario.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__